// Existing Homepage FAQs
export const faqs = [
  {
    id: 1,
    question: "What services does Conectify Tech provide?",
    answer:
      "We provide B2B data, data enrichment, lead generation, email marketing, lead intelligence, company profiling, and recruitment and staffing consulting.",
  },
  {
    id: 2,
    question: "How does your lead generation process work?",
    answer:
      "We start by defining your ideal customer profile, then build and validate a data set before launching multi-channel outreach with ongoing optimization.",
  },
  {
    id: 3,
    question: "Can Conectify Tech provide custom data solutions?",
    answer:
      "Yes. Every engagement starts with your target segments and goals, and the data build is scoped around them rather than a generic list.",
  },
  {
    id: 4,
    question: "What industries do you serve?",
    answer:
      "We work across technology, healthcare, finance, education, real estate, e-commerce, manufacturing, recruitment and professional services.",
  },
  {
    id: 5,
    question: "How can I start a project?",
    answer:
      "Reach out through the contact form or book a call with our team. We'll scope your goals and propose a plan within a few business days.",
  },
];

// Detailed Technical & Data Governance FAQs
export const dataFaqs = [
  {
    id: 6,
    question: "How is Conectify Tech different from other data/list providers?",
    answer:
      "Conectify Tech combines data, insights, and direct connections via our proprietary M-T-V (Multi-sourced, Triangulated, Validated) framework, backed by a dedicated customer success manager.",
  },
  {
    id: 7,
    question: "How does Conectify Tech collect and validate its data?",
    answer:
      "We curate data across 40,000+ sources and over 400M company and contact records, authenticating every field through algorithmic AI triangulation and manual specialist audits.",
  },
  {
    id: 8,
    question: "How reliable is the data and what if information is outdated?",
    answer:
      "We guarantee 95% data accuracy. Users can flag any record with our 'False Info' tool for immediate human re-verification and enrichment.",
  },
  {
    id: 9,
    question: "What is your contact coverage scope?",
    answer:
      "We focus on decision-makers (CxOs, VPs, Directors, Board Members) in companies with 5+ employees to eliminate data clutter, providing 90% coverage across the US and Europe.",
  },
];